
import Vue from "vue";

class ExportXlsx {
    constructor(){

    }
    assemble(tableData){
        let topHTML = ``;
        let colspanNum = 1;
        if(Array.isArray(tableData.thead)){
            colspanNum = tableData.thead.length;
        }
        let filnameHTML = "";
        if(tableData.filename){
            filnameHTML = `<tr>
                <td colspan="${ colspanNum }" style="font-weight: 600;font-size: 16px;color: #507aa4;text-align: center;height: 50px;line-height: 50px;">${ tableData.filename }</td>
            </tr>`;
        }
        if(Array.isArray(tableData.topData)){
            if(tableData.topData.length) {
                topHTML = ``;
                for(let list of tableData.topData){
                    topHTML = topHTML + `<tr><td colspan="${ colspanNum }" style="font-size: 14px;color: #666666;text-align: left;height: 30px;line-height: 30px;">${ list.name }: ${ list.value }</td></tr>`;
                }
            }
        }
        let theadHTML = "";
        if(Array.isArray(tableData.thead)){
            if(tableData.thead.length) {
                theadHTML = `<tr>`;
                for(let list of tableData.thead){
                    theadHTML = theadHTML + `<td style="font-weight: 600;font-size: 14px;color: #507aa4;text-align: center;height: 40px;line-height: 40px;background: #f1f1f1;">${ list }</td>`;
                }
                theadHTML = theadHTML + `</tr>`;
            }
        }
        let tbodyHTML = "";
        if(Array.isArray(tableData.thead)){
            if(tableData.thead.length) {
                tbodyHTML = `<tr>`;
                for(let list of tableData.tbody){
                    tbodyHTML = tbodyHTML + `<td style="font-size: 14px;color: #666666;text-align: center;height: 30px;line-height: 30px;">${ list }</td>`;
                }
                tbodyHTML = tbodyHTML + `</tr>`;
            }
        }
        let tableHTML= `
            <html>
                <head>
                    <meta charset="UTF-8" />
                </head>
                <body>
                    <table cellpadding="0" cellspacing="0" border="1">
                        ${ filnameHTML }
                        ${ topHTML }
                        <thead>${ theadHTML}</thead>
                        <tbody>${ tbodyHTML }</tbody>
                    </table>
                </body>
            </html>
        `;
        return tableHTML;
    }
    download(tableData){
        let tableHTML = this.assemble(tableData);
        let excelBlob = new Blob([tableHTML], { type: "application/vnd.ms-excel" });
        let oA = document.createElement("a");
        oA.href = URL.createObjectURL(excelBlob);
        oA.download = tableData.filename + ".xls";
        document.body.appendChild(oA);
        oA.click();
        document.body.removeChild(oA);
    }
    assemble_maintain(tableData){
        let topHTML = ``;
        let colspanNum = 1;
        if(Array.isArray(tableData.thead)){
            colspanNum = tableData.thead.length;
        }
        let filnameHTML = "";
        if(tableData.filename){
            filnameHTML = `<tr>
                <td colspan="${ colspanNum }" style="font-weight: 600;font-size: 16px;color: #507aa4;text-align: center;height: 50px;line-height: 50px;">${ tableData.filename }</td>
            </tr>`;
        }
        if(Array.isArray(tableData.topData)){
            if(tableData.topData.length) {
                topHTML = ``;
                for(let list of tableData.topData){
                    topHTML = topHTML + `<tr><td colspan="${ colspanNum }" style="font-size: 14px;color: #666666;text-align: left;height: 30px;line-height: 30px;">${ list.name }: ${ list.value }</td></tr>`;
                }
            }
        }
        let theadHTML = "";
        if(Array.isArray(tableData.thead)){
            if(tableData.thead.length) {
                theadHTML = `<tr>`;
                for(let list of tableData.thead){
                    theadHTML = theadHTML + `<td style="font-weight: 600;font-size: 14px;color: #507aa4;text-align: center;height: 40px;line-height: 40px;background: #f1f1f1;">${ list }</td>`;
                }
                theadHTML = theadHTML + `</tr>`;
            }
        }
        let tbodyHTML = "";
        if(Array.isArray(tableData.thead)){
            if(tableData.thead.length) {
                tbodyHTML = "";
                for(let list of tableData.tbody){
                    tbodyHTML = tbodyHTML + "<tr>";
                    for(let item of list){
                        tbodyHTML = tbodyHTML + `<td style="font-size: 14px;color: #666666;text-align: center;height: 30px;line-height: 30px;">${ item }</td>`;
                    }
                    tbodyHTML = tbodyHTML + `</tr>`;
                }
            }
        }
        let tableHTML= `
            <html>
                <head>
                    <meta charset="UTF-8" />
                </head>
                <body>
                    <table cellpadding="0" cellspacing="0" border="1">
                        ${ filnameHTML }
                        ${ topHTML }
                        <thead>${ theadHTML}</thead>
                        <tbody>${ tbodyHTML }</tbody>
                    </table>
                </body>
            </html>
        `;
        return tableHTML;
    }
    download_maintain(tableData){
        let tableHTML = this.assemble_maintain(tableData);
        let excelBlob = new Blob([tableHTML], { type: "application/vnd.ms-excel" });
        let oA = document.createElement("a");
        oA.href = URL.createObjectURL(excelBlob);
        oA.download = tableData.filename + ".xls";
        document.body.appendChild(oA);
        oA.click();
        document.body.removeChild(oA);
    }
}
let exportXlsx = new ExportXlsx();
export default exportXlsx;


// WEBPACK FOOTER //
// ./src/utils/common/export-xlsx.js